import { z } from "zod";
import type { LogicalTimestamp } from "../sync/logical-timestamp.js";
import { CodecError } from "./envelope.js";

/**
 * Phase 9a `LogicalTimestamp` codec. Sits in its own file so both
 * `codec/operation-log.ts` (per-field operations) and
 * `codec/snapshot-mutation.ts` (whole-aggregate mutations) can
 * import the shape without a cycle between them.
 */

export const logicalTimestampJsonSchema: z.ZodType<LogicalTimestamp> = z.object({
  logical: z.number().int().nonnegative(),
  deviceId: z.string().min(1),
});

export function encodeLogicalTimestamp(
  t: LogicalTimestamp,
): Record<string, unknown> {
  return { logical: t.logical, deviceId: t.deviceId };
}

export function decodeLogicalTimestamp(input: unknown): LogicalTimestamp {
  const parsed = logicalTimestampJsonSchema.safeParse(input);
  if (!parsed.success) {
    throw new CodecError(
      "INVALID_PAYLOAD",
      `decodeLogicalTimestamp: ${parsed.error.message}`,
    );
  }
  return parsed.data;
}
